"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var params = exports.params = [{
  "name": "AMPLIFIER EG ATTACK",
  "cc": 28,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [28, 60]
}, {
  "name": "AMPLIFIER EG DECAY",
  "cc": 29,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [29, 61]
}, {
  "name": "AMPLIFIER EG SUSTAIN",
  "cc": 30,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [30, 62]
}, {
  "name": "AMPLIFIER EG RELEASE",
  "cc": 31,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [31, 63]
}, {
  "name": "FILTER EG ATTACK",
  "cc": 23,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [23, 55]
}, {
  "name": "FILTER EG DECAY",
  "cc": 24,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [24, 56]
}, {
  "name": "FILTER EG SUSTAIN",
  "cc": 25,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [25, 57]
}, {
  "name": "FILTER EG RELEASE",
  "cc": 26,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [26, 58]
}, {
  "name": "VCO 1 LEVEL",
  "cc": 15,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [15, 47]
}, {
  "name": "VCO 2 LEVEL",
  "cc": 16,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [16, 48]
}, {
  "name": "NOISE LEVEL",
  "cc": 8,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [8, 40]
}, {
  "name": "VCO 1 SUB LEVEL",
  "cc": 17,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [17, 49]
}, {
  "name": "VCO 1 WAVE",
  "cc": 9,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [9, 41]
}, {
  "name": "VCO 2 WAVE",
  "cc": 14,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [14, 46]
}, {
  "name": "VCO 2 FREQUENCY",
  "cc": 12,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [12, 44]
}, {
  "name": "VCO 2 BEAT FREQUENCY",
  "cc": 13,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [13, 45]
}, {
  "name": "VCO 2 HARD SYNC",
  "cc": 77,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "VCO GATE RESET",
  "cc": 81,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "FILTER CUTOFF FREQUENCY",
  "cc": 19,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [19, 51]
}, {
  "name": "FILTER RESONANCE",
  "cc": 21,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [21, 53]
}, {
  "name": "FILTER KB TRACKING AMOUNT",
  "cc": 27,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [27, 59]
}, {
  "name": "FILTER EG AMOUNT",
  "cc": 22,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [22, 54]
}, {
  "name": "MULTIDRIVE AMOUNT",
  "cc": 18,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [18, 50]
}, {
  "name": "FILTER EG VELOCITY TO AMPLITUDE",
  "cc": 110,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "AMPLIFIER EG VELOCITY TO AMPLITUDE",
  "cc": 92,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "NOTE PRIORITY",
  "cc": 111,
  "type": "enum",
  "values": [[0, "Global"], [32, "Low Note"], [64, "High Note"], [96, "Last Note"]],
  "fourteen": false
}, {
  "name": "RELEASE ON / OFF",
  "cc": 88,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "MODULATION SOURCE",
  "cc": 71,
  "type": "enum",
  "values": [[0, "Triangle LFO"], [16, "Square LFO"], [32, "Saw LFO"], [48, "Ramp LFO"], [64, "S&H"], [80, "Filter Envelope"]],
  "fourteen": false
}, {
  "name": "LFO RATE",
  "cc": 3,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [3, 35]
}, {
  "name": "LFO MIDI SYNC",
  "cc": 102,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "LFO GATE RESET",
  "cc": 93,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "FILTER MOD AMOUNT",
  "cc": 2,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [2, 34]
}, {
  "name": "PITCH MOD AMOUNT",
  "cc": 4,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [4, 36]
}, {
  "name": "WAVE MOD AMOUNT",
  "cc": 20,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [20, 52]
}, {
  "name": "PITCH BEND UP",
  "cc": 107,
  "type": "range",
  "range": [0, 24],
  "fourteen": false
}, {
  "name": "PITCH BEND DOWN",
  "cc": 108,
  "type": "range",
  "range": [0, 24],
  "fourteen": false
}, {
  "name": "GLIDE ON / OFF",
  "cc": 65,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "GLIDE LEGATO",
  "cc": 94,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "GLIDE RATE",
  "cc": 5,
  "type": "range",
  "range": [0, 16383],
  "fourteen": [5, 37]
}, {
  "name": "GLIDE TYPE",
  "cc": 85,
  "type": "enum",
  "values": [[0, "Linear Constant Rate"], [43, "Linear Constant Time"], [85, "Exponential"]],
  "fourteen": false
}, {
  "name": "LFO KB TRACKING AMT",
  "cc": 78,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "AMPLIFIER EG RESET",
  "cc": 83,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "FILTER EG RESET",
  "cc": 82,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "OUTPUT LEVEL",
  "cc": 7,
  "type": "range",
  "randomize": false,
  "range": [0, 16383],
  "fourteen": [7, 39]
}, {
  "name": "KEYBOARD OCTAVE",
  "cc": 89,
  "type": "enum",
  "values": [[0, "-2 Oct"], [16, "-1 Oct"], [32, "+0 Oct"], [48, "+1 Oct"], [64, "+2 Oct"]],
  "fourteen": false
}, {
  "name": "EXTERNAL INPUT LVL",
  "cc": 116,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "AMPLIFIER EG DELAY",
  "cc": 104,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "AMPLIFIER EG HOLD",
  "cc": 106,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "FILTER EG DELAY",
  "cc": 103,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "FILTER EG HOLD",
  "cc": 105,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "PITCH MOD. OSC 2 ONLY",
  "cc": 70,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "MODULATION WHEEL",
  "cc": 1,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "WAVE MOD DESTINATION",
  "cc": 72,
  "type": "enum",
  "values": [[0, "OSC 1 Only"], [43, "OSC 2 Only"], [85, "Both OSC 1 & 2"]],
  "fourteen": false
}, {
  "name": "VCO 1 OCTAVE",
  "cc": 74,
  "type": "enum",
  "values": [[16, "16'"], [32, "8'"], [48, "4"], [64, "2'"]],
  "fourteen": false
}, {
  "name": "VCO 2 OCTAVE",
  "cc": 75,
  "type": "enum",
  "values": [[16, "16'"], [32, "8'"], [48, "4"], [64, "2'"]],
  "fourteen": false
}, {
  "name": "FILTER POLES",
  "cc": 109,
  "type": "enum",
  "values": [[0, "1 POLE"], [32, "2 POLES"], [64, "3 POLES"], [96, "4 POLES"]],
  "fourteen": false
}, {
  "name": "LFO RANGE",
  "cc": 76,
  "type": "enum",
  "values": [[0, "Low (.01 Hz - 10Hz)"], [43, "Mid (.1Hz - 100Hz)"], [85, "High (1Hz - 1kHz)"]],
  "fourteen": false
}, {
  "name": "LEGATO",
  "cc": 68,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "KEYBOARD TRANSPOSE",
  "cc": 119,
  "type": "enum",
  "values": [[0, "-12 Semitones"], [1, "-11 Semitones..."], [12, "+0 Semitones..."], [24, "+12 Semitones"]],
  "fourteen": false
}, {
  "name": "GATED GLIDE",
  "cc": 73,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "FILTER EG REPEAT",
  "cc": 112,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "FILTER EG VELOCITY TO TIME",
  "cc": 86,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "FILTER EG KB AMOUNT",
  "cc": 79,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "FILTER EG GATE SOURCE",
  "cc": 90,
  "type": "enum",
  "values": [[0, "Gate On"], [32, "Keys Only"], [64, "Gate Only"], [96, "Keys or Gate Input"]],
  "fourteen": false
}, {
  "name": "AMPLIFIER EG REPEAT",
  "cc": 113,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "AMPLIFIER EG VELOCITY TO TIME",
  "cc": 87,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "AMPLIFIER EG KB AMOUNT",
  "cc": 80,
  "type": "range",
  "range": [0, 127],
  "fourteen": false
}, {
  "name": "VOLUME EG GATE SOURCE",
  "cc": 91,
  "type": "enum",
  "values": [[0, "Gate On"], [32, "Keys Only"], [64, "Gate Only"], [96, "Keys Or Gate Input"]],
  "fourteen": false
}, {
  "name": "FILTER EG TRIGGER MODE",
  "cc": 114,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}, {
  "name": "AMPLIFIER EG TRIGGER MODE",
  "cc": 115,
  "type": "checkbox",
  "off": 0,
  "on": 64,
  "fourteen": false
}];